import type { RollbarConfig } from "../models/rollbar";

export const baseUrl = process.env.REACT_APP_BASE_URL || "";
export const assetsUrl = process.env.REACT_APP_ASSETS_URL || "";
export const participantPortalUrl =
  process.env.REACT_APP_PARTICIPANT_PORTAL_URL || "";

export const rollbarConfig: RollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
  captureUncaught: true,
  captureUnhandledRejections: true,
};

export const accessTokenCookieName =
  process.env.REACT_APP_ACCESS_TOKEN_COOKIE_NAME || "";
export const refreshTokenCookieName =
  process.env.REACT_APP_REFRESH_TOKEN_COOKIE_NAME || "";
